import { BreakSetupModule } from '../../../../components/displays/alerts/components/addAlertComponent/addAlertForm/formComponents/setup/setupDetails/setupDetailsModules/break/BreakSetupModule';
import { BreakDetailsComponent } from '../../../../components/displays/alerts/components/alertWatchlistComponent/setupDetailsComponents/break/BreakDetailsComponent';
import { parseBreakNotificationDetails } from '../../../../components/displays/alerts/components/notificationComponent/notificationListItem/notificationSetupParsers/parseBreakNotificationDetails';
import { BreakLine } from '../../../../components/displays/charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/setups/BreakLine';
import { SimpleBreakSetupLine } from '../../../../components/displays/newTradingInterface/tradingModule/components/chart/chartElements/tacticLines/SimpleBreakSetupLine';
import { BreakTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/individualTacticPanels/setups/BreakTacticPanel';
import BreakWrapper from '../../../../components/displays/tradeplans/softOrderModules/setupModules/breakModule/wrapper/BreakWrapper';
import breakDoc from '../../../../components/forms/tradeplans/documentation/BreakDocumentation';
import { breakDetailParser } from '../../../../stores/websocketStore/utils/mungingUtils/alertSoftOrderProcessing/individualSetupDetailParsers/break/breakDetailParser';
import { BreakData } from './breakData';
import { validateBreak } from './validateBreak';



export const Break = {
  //data class
  dataStore: BreakData,

  //string constants
  name: 'BREAK',
  tacticLabel: 'Break',
  addTacticLabel: 'Add Candle Pattern',
  category: 'Setup',

  //components
  tradePlanFormModule: null,
  tacticPanel: BreakTacticPanel,
  addTacticPanel: null,
  wrapper: BreakWrapper,
  chartSoftOrderComponent: BreakLine,
  documentation: breakDoc,
  alertDetailsComponent: BreakSetupModule,
  alertTableSetupComponent: BreakDetailsComponent,
  simpleChartComponent: SimpleBreakSetupLine, 

  // functions
  setupDetailParser: breakDetailParser,
  setupNotificationParser: parseBreakNotificationDetails,
  determineTimeUnit: () => null,
  determineCandleDuration: () => null,
  validateFunction: validateBreak,
};
